const getEnvVars = () => (typeof window !== 'undefined' ? window.env : {})

export default getEnvVars()
